import React, {FC} from "react";
import {Card} from "react-bootstrap";
import {Field} from "formik";
import {FormikRowInput} from "@components/panel/formik";

const BaseInfoBlock: FC = () => {
    return (
        <Card className="mb-3">
            <Card.Header as="h6" className="bg-body-tertiary">
                Основное
            </Card.Header>
            <Card.Body>
                <Field
                    label='Название'
                    type='text'
                    name='name'
                    placeholder='Название группы'
                    component={FormikRowInput}
                />
                <Field
                    label='Описание'
                    name='description'
                    type='textarea'
                    rows={4}
                    placeholder='Описание группы'
                    component={FormikRowInput}
                />
            </Card.Body>
        </Card>
    )
}

export default BaseInfoBlock;
